export class ConstantMan {
  public static BUCKETS = {
    LOCAL: 'anchor-rides-alpha',
    DEV: 'anchor-rides-alpha',
    STAGE: 'anchor-rides-beta',
    PROD: 'anchor-rides',
  };

  public static MEDIA_ENV_NAMES = {
    LOCAL: 'alpha',
    ALPHA: 'alpha',
    BETA: 'beta',
    PROD: 'prod',
  };

  public static CLIENT = {
    BASE: {
      LOCAL: 'http://localhost:4200/',
      DEV: 'https://test.anchorrides.com/',
      STAGE: 'https://test-mobile.anchorrides.com/',
      PROD: 'https://www.anchorrides.com/',
    },
  };

  public static API = {
    BASE: {
      LOCAL: 'http://localhost:3000/',
      DEV: 'https://api-test.anchorrides.com/',
      STAGE: 'https://api-test-mobile.anchorrides.com/',
      PROD: 'https://api.anchorrides.com/',
    },
    RESOURCE: {
      USER: 'users',
      CUSTOMER: 'customers',
      CUSTOMER_REVIEW: 'customer-reviews',
      POSTS: 'posts',
      AFFILIATE: 'affiliates',
      ABANDONED_BUYFLOW: 'abandoned-buyflow',
      CHARTER_NOTE: 'charter-notes',
      LOGIN: 'login',
      LOGOUT: 'logout',
      SESSION: 'session',
      PUBLIC_SESSION: 'public-session',
      ROLE: 'roles',
      PERMISSION: 'permissions',
      PROFILE: 'profile',
      JOB_SITE: 'jobsites',
      SAMPLE: 'samples',
      WATER_BODY: 'waterbodies',
      FILE: 'upload',
      CAPTAIN: 'captains',
      BOOKING: 'bookings',
      DISCOUNT: 'discounts',
      VESSEL: 'Vessels',
      VESSEL_CAPTAIN: 'vessel-captain',
      SERVICE_RECORD: 'servicerecords',
      VESSEL_IMAGE: 'VesselImages',
      VESSEL_RATE: 'VesselRates',
      VESSEL_SPLIT_RATE: 'vessel-split-rates',
      ADD_ON: 'add-ons',
      CHARTER: 'charters',
      OFFER: 'offers',
      CAPTAIN_MANAGE_DETAILS: 'captain-manage-details',
      PAYOUT: 'payouts',
      SUBPAYOUT: 'sub-payouts',
      PAYSTUB: 'paystub',
      BOATOWNER: 'boatowners',
      STATUS: 'status',
      CREWMEMBER: 'crewmembers',
      PAYMENT: 'payments',
      MARKET: 'markets',
      MOORING_LOCATION: 'MooringLocations',
      REPORT: 'reports',
      GOOGLE_AUTH_URL: 'google-url',
      GOOGLE_TOKEN: 'google-token',
      GOOGLE_CREATE: 'google-create',
      CREATE_BOAT_OWNER_CAL: 'boat-owner/google-create',
      SYNC_BOAT_OWNER_CAL: 'boat-owner/google-sync',
      GOOGLE_USER_INFO: 'google-user-info',
      VESSEL_AVAILABILITY_PREFERENCES: 'vessel-availability-preferences',
      CHARTER_VESSEL_AVAILABILITY: 'charter-vessel-availability',
      PRODUCT_OFFERING: 'product-offering',
      VESSEL_CALENDAR_PREFERENCES: 'calendar-preferences',
      LOGGING: 'logging',
      CHARTER_ALTERNATE_TIME_REQUESTS: 'charter-alternate-time-requests',
      CAPTAIN_GIG: 'captain/gig',
      HUBSPOT_CONTACT_PROPERTIES: 'hubspot-contact-properties',
      VESSEL_AVAILABILITY: 'vessel-availability',
      CHARTER_PAYMENTS: 'charter-payments',
      STRIPE_PAYMENTS: 'stripe',
      COMET_CHAT_AUTH_URL: 'cometchat/auth',
      COMETCHAT_MESSAGING: 'cometchat/messaging',
    },
    GET_METHODS: ['GET', 'HEAD', 'JSONP', 'OPTIONS'],
  };

  public static STATUS_TYPE = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  };

  public static PAYOUT_TYPES = {
    OWNER: 'owner',
    CAPTAIN: 'captain',
    CREW: 'crew',
  };

  /**
   * Must match Settings -> Connect Settings in the Stripe Account
   */
  public static STRIPE_REDIRECTS = {
    LOCAL: 'http://localhost:4200/',
    DEV: 'https://test.anchorrides.com/',
    STAGE: 'https://test-mobile.anchorrides.com/',
    PROD: 'https://www.anchorrides.com/',
  };

  public static USER_NOTIFICATION_MESSAGES = {
    USER_ENROLL_SUCCESS:
      'Please check your email to confirm your email address',
    USER_ENROLL_ERROR: 'There was an error enrolling the user',
  };

  // Default permissions ALL roles will always have.
  // Match these up with permissions.sql (node-api).
  public static DEFAULT_PERMISSIONS = [
    1, // Get all permissions
    2, // Get all roles
  ];

  public static VESSEL_STATUSES = {
    DRAFT: 'draft',
    PENDING: 'pending',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  };

  public static CHARTER_STATUSES = {
    LEAD: 'lead',
    OPEN: 'open',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
  };

  public static VESSEL_QUERY_PARAMS = {
    LOS: {
      CHARTER: 'charter',
    },
    STATUS: {
      UNAPPROVED: 'unapproved',
    },
  };

  public static TOKENS = {
    SEND_MESSAGE_KEY: 'h30djd393hfduhu834ghu0h094fuh34fha',
    SEND_MESSAGE_TO_REQUESTS_KEY: 'EBB0B68F-DEF5-49C7-9555-200DC7ABAEB1',
    BRAINTREE: {
      SANDBOX: 'sandbox_qngmfvn4_4y86wq99c5vsbq49',
      PRODUCTION: 'production_prmjwtjq_92xhqt5x7qjnbbpg',
    },
  };

  public static PATTERNS = {
    ZIP: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
    DATE: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    PHONE: [
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    YEAR_BETWEEN_1900_AND_2023: [/(^(19[0-9]{2}|20[0-2][0-3])$)/],
  };

  public static VESSEL_FORM_TABS = {
    BOAT_INFORMATION: 'Boat Information',
    BOAT_LOCATION: 'Boat Location',
    DESCRIPTION_AND_FEATURES: 'Description & Features',
    PHOTOS_AND_VIDEO: 'Photos & Video',
    CAPTAIN_INFO: 'Captain Information',
    PRICING_EDITOR: 'Pricing Editor',
    INSURANCE: 'Declarations',
    NOTES: 'Notes',
    CHARTER_SCHEDULE: 'Calendar',
    AVAILABILITY: 'Availability',
    HISTORY: 'History',
    ADMIN: 'Admin',
    REQUEST_EDIT: 'Request Edit',
  };

  public static VESSEL_FORM_TABS_ARRAY = [
    ConstantMan.VESSEL_FORM_TABS.BOAT_INFORMATION,
    ConstantMan.VESSEL_FORM_TABS.BOAT_LOCATION,
    ConstantMan.VESSEL_FORM_TABS.DESCRIPTION_AND_FEATURES,
    ConstantMan.VESSEL_FORM_TABS.PHOTOS_AND_VIDEO,
    ConstantMan.VESSEL_FORM_TABS.CAPTAIN_INFO,
    ConstantMan.VESSEL_FORM_TABS.PRICING_EDITOR,
    ConstantMan.VESSEL_FORM_TABS.INSURANCE,
    ConstantMan.VESSEL_FORM_TABS.NOTES,
    ConstantMan.VESSEL_FORM_TABS.CHARTER_SCHEDULE,
    ConstantMan.VESSEL_FORM_TABS.AVAILABILITY,
    ConstantMan.VESSEL_FORM_TABS.HISTORY,
    ConstantMan.VESSEL_FORM_TABS.ADMIN,
  ];

  public static MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  public static timeSelections = [
    '8:00 AM',
    '8:30 AM',
    '9:00 AM',
    '9:30 AM',
    '10:00 AM',
    '10:30 AM',
    '11:00 AM',
    '11:30 AM',
    '12:00 PM',
    '12:30 PM',
    '1:00 PM',
    '1:30 PM',
    '2:00 PM',
    '2:30 PM',
    '3:00 PM',
    '3:30 PM',
    '4:00 PM',
    '4:30 PM',
    '5:00 PM',
    '5:30 PM',
    '6:00 PM',
    '6:30 PM',
    '7:00 PM',
    '7:30 PM',
    '8:00 PM',
  ];

  public static APP_CALENDAR = {
    UNAVAILABLE: 'UNAVAILABLE',
    DAILY_CONFIGURATION: 'DAILY_CONFIGURATION',
    ALLOCATED: 'ALLOCATED',
    AVAILABLE: 'AVAILABLE',
    CHARTER_PLACEHOLDER: 'SELECTED',
    GOOGLE_EVENT: 'GOOGLE_EVENT',
  };

  public static DEPOSIT_STATUS = {
    NOT_SENT: 'NOT SENT',
    SENT: 'SENT',
    PAID: 'PAID',
  };

  public static PAYMENT_STATUS = {
    NOT_SENT: 'NOT SENT',
    SENT: 'SENT',
    PAID: 'PAID',
  };

  public static ENVIRONMENTAL_MEDIA_CONFIG = {
    BASE: 'https://anchor-public-media.s3.us-east-2.amazonaws.com/',
  };

  public static ENVIRONMENTAL_MEDIA_MAP = {
    HOME_PAGE: {
      DIAMOND_ICON: 'diamond-icon.svg',
      LUXURY_YACHT: 'luxury-yacht.jpg',
      PLAY_BUTTON: 'play-button.png',
      LIST_YOUR_BOAT_ICON: 'list-your-boat-icon.svg',
      CAPTAIN_ICON: 'captain.svg',
      CAPTAIN_JPG: 'captain.jpg',
      LIST_YOUR_BOAT_JPG: 'list-your-boat.jpg',
      HOME_HERO: 'hero.jpg',
      HOME_HERO_SM: 'hero-sm.jpg',
    },
    PASSENGERS_ICON: 'passengers-icon.svg',
    CABIN_ICON: 'cabins-icon.svg',
    BED_ICON: 'bed-icon.svg',
    RESTROOMS_ICON: 'restrooms-icon.svg',
    SHOWERS_ICON: 'showers-icon.svg',
    THANK_YOU_HEADER_JPG: 'thankyou-header.jpg',
  };

  public static PROCESSING_FEE = {
    BASE: 0.025,
    GET_TOTAL_FROM_BASE: 0.975,
  };

  public static PRICING_TYPES = {
    FULL: 'full',
    HALF: 'half',
  };

  public static VESSEL_PREFS = {
    PRODUCT_FORM: 'create-custom-time-products',
    RESERVATION_SETTINGS: 'reservation-settings',
  };

  public static MAP_PAGINATION = {
    LIMIT: 26,
  };

  public static VESSEL_SORT_ORDER = {
    PRICE_ASC: ['halfDayPrice', 'ASC'],
    PRICE_DESC: ['halfDayPrice', 'DESC'],
    LENGTH_ASC: ['length', 'ASC'],
    LENGTH_DESC: ['length', 'DESC'],
  };

  public static NO_NAV_LIST = ['/customer/review'];
  public static NO_MOBILE_NAV_LIST = ['/customer/booking'];
  public static NO_FOOTER_LIST = [
    '/manage',
    '/customer/charters',
    '/customer/review',
    '/customer/messages',
    '/customer/booking',
  ];

  public static GET_DEFAULT_OFFER_NOTE = (name: string) =>
    `Hi ${name}, we're sorry our calendar was not updated. I've made some changes to your request and sent you a special offer. If you accept our offer, we're happy to host you.`;
}
